import _ from 'lodash';
import REST from '../rest';

const ENDPOINT = 'api/v1/categories';

const queryParams = (params = {}) => {
  const paramsCopy = { ...params };

  if (_.isString(params.reportSearch) && !_.isEmpty(params.reportSearch)) {
    Object.assign(paramsCopy, { report_search: paramsCopy.reportSearch });
    delete paramsCopy.reportSearch;
  }

  return paramsCopy;
};

export const load = (params) => REST.get(ENDPOINT, _.get(params, 'id'), queryParams(params));
export const create = (data) => REST.post(ENDPOINT, data);
export const edit = (id, data) => REST.patch(ENDPOINT, id, data);
export const deleteCategory = (id) => REST.delete(ENDPOINT, id);
